import {createApp} from 'vue';
import MdMostReadCounter from './multiMostRead/Counter.vue'
import MdMostReadEntries from './multiMostRead/Entries.vue'

const app = createApp({
    components: {
        MdMostReadCounter,
        MdMostReadEntries
    },
});
let elements = document.getElementsByClassName('multi-most-read-app');
for (let el of elements) {
    app.mount(el);
}